<template>
  <div class="home">
    <section class="hero">
      
      <div class="content container">
        <div class="grid">
        
          <div class="hero-image col col-md-6">
            <BaseImage
              src="turnKeyOnDevices.png"
              alt="turnKey website running on multiple devices"
              width="800"
              height="600"
              aspect-ratio="4/3"
              @error="handleImageError"
            />
            
          </div>
        
          <div class="col col-md-6">
            <div class="text-content">
              <p v-for="(paragraph, index) in home.mainContent.introduction"
                 :key="index"
                 :class="{ 'first-paragraph': index === 0 }">
                {{ paragraph }}
              </p>
            </div>
          </div>
        </div>
      </div>

    </section>

    <!-- Removed for Launch 
    <div class="bg-blue-bright border-top">
      <div class="content container pb-lg">
        <section class="features">
        
          <h2>Our Solutions</h2>
          <div class="grid feature-grid">
            <div class="feature-card col-12 col-xs-12 col-md-4 col-lg-4">
              <h3>{{ forCRCs.card.title }}</h3>
              <p>{{ forCRCs.card.text }}</p>
              <router-link :to="`${ forCRCs.card.link }`" class="btn weird">{{ forCRCs.card.action }}</router-link>
            </div>
            <div class="feature-card col-12 col-xs-12 col-md-4 col-lg-4">
              <h3>{{ forRDCs.card.title  }}</h3>
              <p>{{ forRDCs.card.text }}</p>
              <router-link :to="`${ forRDCs.card.link }`" class="btn weird">{{ forRDCs.card.action }}</router-link>
            </div>
            <div class="feature-card col-12 col-xs-12 col-md-4 col-lg-4">
              <h3>{{ forResMan.card.title }}</h3>
              <p>{{ forResMan.card.text }}</p>
              <router-link :to="`${ forResMan.card.link }`" class="btn weird">{{ forResMan.card.action }}</router-link>
            </div>
          </div>
        </section>
      </div>
    </div>
    -->
    <div class="border-top">
      <div class="content container mb-sm">
        <section class="features">
        
          <h2>{{ home.mainContent.advantages.title }}</h2>

          <div class="grid advantage-grid">
            <div v-for="(advantage, index) in home.mainContent.advantages.list" :key="index"
             class="col-12 col-xs-12 col-md-4 col-lg-4"  >

              <CardWithIcon
                :key="index"
                :icon="advantage.icon"
                :text="advantage.text"
                color="orange"
                layout="two-column"
              />
            </div>

          </div>

        </section>
      </div>
    </div>
    <div class="bg-blue-bright border-top">
      <div class="content container">
        <section class="features">
        
          <!--
          <h2>Our Solutions</h2>
          -->
          <div class="grid feature-grid">
            <div class="feature-card col-12">
              <h3>
                {{ home.mainContent.card.title }}
              </h3>
              <p>
                {{ home.mainContent.card.text }}
              </p>
              <router-link :to="home.mainContent.card.link" class="btn weird">{{ home.mainContent.card.action }}</router-link>
            </div>
            
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import home from '@/content/home.yml';
import forCRCs from '@/content/turnKeyForCRCs.yml';
import forRDCs from '@/content/turnKeyForRDCs.yml';
import forResMan from '@/content/turnKeyForResMan.yml';
import ogImage from '@/assets/opengraph/turnKey.png'

const handleImageError = (error) => {
  console.error('Image failed to load:', error)
}

</script>

<style lang="scss" scoped>
.home {
  //max-width: 800px;
  margin: 0 auto;
  padding-top: $spacing-xl;

  //border-bottom: 4px solid $orange;

  .hero {
    margin-bottom: $spacing-xl;

    .hero-image {
      max-width: 1000px;
      margin: 0 auto;
      padding: 0 1rem;
    }


    }
  }

  .features {
    padding: $spacing-lg 0;

    h2 {
      text-align: center;
      margin-bottom: $spacing-lg;
      color:$blue-dark;
    }
    /**
    .feature-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//      gap: $spacing-lg;
    }
**/

    

    .feature-card {
      background: $color-white;
      padding: $spacing-lg;
      padding-bottom: $spacing-sm;
      border-radius: $border-radius;
      box-shadow: $shadow-sm;
      text-align: center;
      display: grid;
      grid-template-rows: auto auto 1fr auto;
      gap: $spacing-md;
      height: 100%;

      h3 {
        color: $blue-dark;
        margin-bottom: 0;
      }

      p {
        margin-bottom: 0;
      }

      .btn {
        align-self: end;
        justify-self: center;
      }
    }
  }

</style> 